
import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { triggerAggregator } from "@/integrations/cfs/aggregator";
import { Zap } from "lucide-react";

export function DataAggregatorTest() {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<any>(null);
  const { toast } = useToast();

  const handleTestAggregator = async () => {
    setLoading(true);
    try {
      // Test data for aggregator
      const testData = {
        source: "payment_page",
        timestamp: new Date().toISOString(),
        data: {
          customer_id: "CUST123456",
          transaction_type: "payment",
          amount: 150000,
          products: [
            { id: "PROD001", name: "Basic Subscription", price: 100000 },
            { id: "PROD002", name: "Add-on Feature", price: 50000 }
          ],
          metadata: {
            device: navigator.userAgent,
            referrer: document.referrer
          }
        }
      };

      const result = await triggerAggregator(testData);
      
      setResponse(result);
      
      toast({
        title: "Success",
        description: "Data successfully aggregated and sent to CFS",
      });
    } catch (error: any) {
      console.error('Aggregator test error:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "Failed to trigger data aggregation",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Data Aggregator & CFS Trigger Test</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <Button 
            onClick={handleTestAggregator}
            disabled={loading}
            variant="outline"
          >
            {loading ? "Processing..." : "Test Data Aggregation & CFS Trigger"}
            <Zap className="ml-2 h-4 w-4" />
          </Button>

          {response && (
            <div className="mt-4">
              <h3 className="font-semibold mb-2">Aggregator Response:</h3>
              <pre className="bg-gray-100 p-4 rounded-lg overflow-auto max-h-96">
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
